module.exports = __webpack_public_path__ + "static/media/documents-icon-yellow.4a31ac87.svg";